
import ConfigService from './configurationService.js';
import UrlService from './urlService';
import mktRegionMapping from './regionMapping.js';

/**
 *
 * TdcStrings
 *
 * @namespace TdcStrings
 */
var TdcStrings = function() {
    "use strict";

    var neededStrings = {
        cart: {
            adrContinueTxt: '',
            adrShipDay: '',
            minPsvErrorTxt: '',
            minPsvWarningTxt: '',
            numAdrsTxt: '',
            qtyChangedAtpErrorTxt: '',
            replaceOnAdrListHeader: '',
            scanCardLimitTxt: '',
            searchAtpErrorTxt: ''
        },
        checkout: {
            contractLengthTextSmall: '',
            firstOrderText: '',
            firstShipTextSmall: '',
            recurringOrderTextFuture: '',
            recurringOrderTextImmediate: '',
            recurringShipDayTextSmall: '',
            replacement: '',
            selectContractLengthText: '',
            agelocLoyaltyContractText: ''
        }
    };

    var getTdcStrings = function(page, language, country, angApp) {
        return doStringsRequest(page, language, country, angApp, 'noTdc_');
    };

    var getNonTdcStrings = function(page, language, country, angApp) {
        return doStringsRequest(page, language, country, angApp, 'nonTdc');
    };

    function doStringsRequest(page, language, country, angApp, mode) {
        var tdc = {};
        var url;

        if (UrlService.isMeCommerce()){
            url = window.location.protocol + "//" + window.location.host + '/content/mecommerce/{region}/{market}/{language}/shop/{page}.service.' + mode + '.json';
            url = url.replace('{region}', mktRegionMapping[country]).replace('{market}', country).replace('{language}', language).replace('{page}', page);
        }
        else{
            url = UrlService.extractHostURL(ConfigService.getMarketConfig().tdcStringsUrl);
            if (typeof url !== "undefined") {
                url = url.replace('{language}', language).replace('{market}', country).replace('{page}', page).replace('.noTdc_.', '.' + mode + '.');
            }
        }

        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            async:false,
            success: function(data) {
                tdc = addNeededStrings(data, neededStrings[page]);
                tdc = transformTdcStrings(tdc);
            },
            error: function(xhr) {
                console.log("could not load tdc for the Checkout! error:"+xhr);
            }
        });

        if (angApp) {
            angApp.constant("TDC", tdc);
        }

        return tdc;
    }

    function transformTdcStrings(tdc) {
        var adrProgram = ConfigService.getMarketConfig().adrProgram || 'ADR',
            tdcString;

        for (tdcString in tdc) {
            if (tdc.hasOwnProperty(tdcString)) {
                tdc[tdcString] = replaceAdrProgram(tdc[tdcString], adrProgram);
                tdc[tdcString] = escapeIllegalLinks(tdc[tdcString]);
//            str = StringEscapeUtils.escapeHtml4(str);


                if (tdcString === 'processMyAdrText') {
                    tdc[tdcString] = tdc[tdcString].replace('<p>', '').replace('</p>', '');
                }
            }

        }

        return tdc;
    }

    function addNeededStrings(tdc, requiredStrings) {
        if (requiredStrings) {
            for (var neededString in requiredStrings) {
                if (requiredStrings.hasOwnProperty(neededString)) {
                    if (!tdc[neededString]) {
                        tdc[neededString] = requiredStrings[neededString];
                    }
                }
            }
        }

        return tdc;
    }

    function escapeIllegalLinks(str) {
        var retStr = str ? str : "";

        if (typeof retStr === 'string') {
            retStr = retStr.replace("author.nuskin","www.nuskin");
        }

        return retStr;
    }

    function replaceAdrProgram(str, adrProgram) {
        var retStr = str ? str : "";

        if (typeof retStr === 'string') {
            retStr = retStr.replace("ADR", adrProgram);
        }
        return retStr;
    }

    return {
        getStrings: getTdcStrings,
        getNonTdcStrings: getNonTdcStrings
    }
}();

export default TdcStrings;



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/tdcStrings.js
// module id = 183
// module chunks = 0